// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZPPF","fullView":"styles_fullView__3n6gQ"};